import { Heading, Box, Badge } from "@radix-ui/themes";
import PropTypes from "prop-types";
import { Trans } from "@lingui/react";

Header.propTypes = {
  name: PropTypes.string,
};

export default function Header({ name }) {
  return (
    <Box>
      <img
        src="/header-logo.webp"
        alt={`${name} Logo`}
        style={{ width: "140px" }}
      />
      <Box>
        <Heading as="h1" size="5" style={{ display: "inline" }}>
          {name}
        </Heading>
      </Box>
    </Box>
  );
}
